// extracted by mini-css-extract-plugin
export default {"icons":"Menu_icons__rvLcY","headerDropdown":"Menu_headerDropdown__GPyWw","icon":"Menu_icon__e-ubF","dropdown":"Menu_dropdown__7i27a","show":"Menu_show__3-cE2"};